// @flow

import React from 'react';
import { colors } from '../constants';

type Props = {
  size: string,
  color: string,
};

function ReportIcon({ size = '20', color = colors.mediumGrey }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        d="M3.25 5a.75.75 0 00-1.5 0v10c0 .414.336.75.75.75h15a.75.75 0 000-1.5H3.25V5z"
        fill={color}
      />
      <path
        d="M11.03 11.53l5.5-5.5-1.06-1.06-4.97 4.97-1.47-1.47a.75.75 0 00-1.06 0l-3 3 1.06 1.06 2.47-2.47 1.47 1.47a.75.75 0 001.06 0z"
        fill={color}
      />
    </svg>
  );
}

export default ReportIcon;
